import { FC, ReactNode, useEffect, useRef, useState } from 'react';

import { cn } from '@/lib/utils';
import PdfHeader from './PdfHeader';
import PdfFooter from './PdfFooter';
import LoadingOverlay from '../../layout/LoadingOverlay';
import useScalable from '@/hooks/useScalable';
import useScalableTransform from '@/hooks/useScalableTransform';

type Props = {
  children: ReactNode;
  id?: string;
  isDynamicHeight?: boolean;
  className?: string;
  isLoading: boolean;
};

export const PDF_WIDTH = 794;

export const HeightOfPDF = 'h-[1146px]';
export const WidthOfPDF = 'max-w-[794px]';
export const BOTTOM_BLOCK = 'bottom-block';
export const BOTTOM_CONTENT = 'bottom-block-content';

const PdfTemplate: FC<Props> = ({ id, className, isLoading, children }) => {
  const elInputContainer = useRef<HTMLDivElement | null>(null);
  const [isPageRendered, setIsPageRendered] = useState(false);

  useScalable(true);

  useScalableTransform(isPageRendered, elInputContainer);

  useEffect(() => {
    if (!elInputContainer.current) {
      return;
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];

      if (entry.contentRect.width > 0 && entry.contentRect.height > 0) {
        setIsPageRendered(true);
        observer.disconnect();
      }
    });

    observer.observe(elInputContainer.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="w-full h-full">
      <div
        id="scalable-wrapper"
        className="scalable-wrapper h-full"
      >
        <LoadingOverlay isOpen={isLoading} />
        <div
          ref={elInputContainer}
          className={'w-[794px] mx-auto'}
        >
          <div id="PdfContent">
            <div className="flex justify-center flex-col items-center ">
              <div className={cn('px-6 w-full')}>
                <div className={cn('w-full')}>
                  <PdfHeader />
                </div>
                <div
                  id={id}
                  className={cn('w-full pb-6 relative', className)}
                >
                  {children}
                </div>
              </div>
              <PdfFooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfTemplate;
